/**
 * Module-level mutable ref that bridges StepUpProvider (which writes to it)
 * and the Axios interceptor inside ApiClientProvider (which reads from it).
 */
export const stepUpRequestRef = { current: null };
